import {autoserializeAs, inheritSerialization} from 'cerialize';
import {ModelBase} from './model-base';

@inheritSerialization(ModelBase)
export abstract class RsvpQuestion extends ModelBase {
  public static readonly type: 'RsvpOpenQuestion' | 'RsvpMultipleChoiceQuestion';
  public readonly type: 'RsvpOpenQuestion' | 'RsvpMultipleChoiceQuestion';

  @autoserializeAs('id')
  public id: number;

  @autoserializeAs('event_id')
  public eventId: number;

  @autoserializeAs('order')
  public order: number;

  @autoserializeAs('title')
  public title = '';

  @autoserializeAs('group_ids')
  public groupIds: number[] = [];
}
